import { useMutation, useQueryClient } from "@tanstack/react-query";
import { operations } from "../openapi/generated-types.ts";
import { createUser } from "../openapi/api-client.ts";

export const useCreateUser = (projectId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      body: operations["user.create"]["requestBody"]["content"]["application/json"],
    ) => {
      return createUser(body, {
        path: { projectId },
      });
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ["users", { projectId }],
        }),
      ]);
    },
  });
};
